export interface Node {
  azureAppId?: number;
  module?: number;
  id?: string;
  path: string;
  description?: string;
  title: string;
  parentId?: string;
  selected?: boolean;
  children?: Node[];
  expanded?: boolean;
  isStatic?: boolean;
}

export interface Navigation {
  module: Node;
  tree: Node[];
  homeUrl?: string;
  isDashboard?: boolean;
}

export enum ModuleEnum {
  Dashboard = 0,
  Submissions = 4,
}

export enum EnvironmentColourEnum {
  Development = 'rgba(255, 97, 198, 0.58)',
  SystemTest = 'rgba(219, 0, 0, 0.58)',
  Bpt = 'rgba(159, 66, 169, 0.58)',
  Prelive = 'rgba(67, 169, 66, 0.58)',
  Default = '@secondary-90'
}
